"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const summithill_models_1 = require("@clearsummit/summithill-models");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const constants_1 = __importStar(require("@/constants"));
const selectors_1 = __importDefault(require("@/selectors"));
const __1 = require("..");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Footer = ({ user }) => (react_1.default.createElement("footer", { className: styles_scss_1.default.footer }, user && user.isValid && (user === null || user === void 0 ? void 0 : user.group) === summithill_models_1.GroupType.PATIENT ? (react_1.default.createElement("div", { id: 'bottomBarContainer', className: styles_scss_1.default.bottomBarContainer },
    react_1.default.createElement(__1.BottomTabsBar, null,
        react_1.default.createElement(__1.BottomTabsBar.Tab, { to: constants_1.Routes.Program, label: constants_1.default.footer.program, icon: { default: constants_1.Images.clipboard, active: constants_1.Images.clipboardActive } }),
        react_1.default.createElement(__1.BottomTabsBar.Tab, { to: constants_1.Routes.Profile, label: constants_1.default.footer.profile, icon: { default: constants_1.Images.user, active: constants_1.Images.userActive } }),
        react_1.default.createElement(__1.BottomTabsBar.Tab, { to: constants_1.Routes.Support, label: constants_1.default.footer.support, icon: { default: constants_1.Images.helpCircle, active: constants_1.Images.helpCircleActive } })))) : null));
exports.Footer = Footer;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
});
exports.default = react_redux_1.connect(mapStateToProps, null)(exports.Footer);
